import Vue from "vue"
import { errorLevels } from "@/store/constants"

/*  State consists of an error array
    Array of {
        code: String - serves as id
        message: String - human readable error
        type: String - refers to type or location of the error
    }                                  
*/
const errorStore = {
  namespaced: true,
  state: {
    errors: []
  },
  mutations: {
    /* ADD_ERROR: (state, payload) => {}, */

    REMOVE_ERROR: (state, payload) => {
      Vue.set(state, "errors", [
        ...state.errors.filter(error => error.code != payload.code)
      ])
    }
  },
  actions: {
    ERRORS_ADD({ commit }, payload) {
      commit("ADD_ERROR", payload)
    },
    ERRORS_REMOVE({ commit }, payload) {
      commit("REMOVE_ERROR", payload)
    }
  },

  getters: {
    GET_SHOW_GLOBAL_ERROR: state => {
      return (
        state.errors.find(error => error.level == errorLevels.GLOBAL) || null
      )
    }
  }
}

export default errorStore
